import React from 'react'
import styled from 'styled-components'

export default function Slider() {
  return (
    <Container className="slider" x-data="{start: true, end: false}">
        <div className="slider__content" x-ref="slider">
    <div className="slider__item">
      <img loading="lazy" className="slider__image" src="/assets/slider/slider1.jpg" alt="Image" /> {/* eslint-disable-line */}
      <div className="slider__info">
        <h2></h2> {/* eslint-disable-line */}
      </div>
    </div>
    <div className="slider__item">
      <img loading="lazy" className="slider__image" src="/assets/slider/slider2.jpg" alt="Image"/> {/* eslint-disable-line */}
      <div className="slider__info">
        <h2></h2> {/* eslint-disable-line */}
      </div>
    </div>
  </div>
</Container>
  )
}

const Container = styled.div`
    width: 85%;
  max-width: 1280px;
  margin: 0 auto;

    .slider__content {
  overflow-x: scroll;
  scroll-snap-type: x mandatory;
  display: flex;
  gap: 1rem;
  padding-bottom: 1rem;
  scrollbar-color: #cbb16d #111;

  &::-webkit-scrollbar {
    height: 0.5rem;
    width: 0.5rem;
    border-radius: 1rem;
    background: #111;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 1rem;
    background: #cbb16d;
  }

  &::-webkit-scrollbar-track {
    border-radius: 1rem;
    background: #111;
  }
}

.slider__item {
  scroll-snap-align: start;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  min-width: 100%;
  width: 100%;
  border-radius: 0.25rem;
  overflow: hidden;
  position: relative;
  aspect-ratio: 1;

  @media (min-width: 460px) {
    aspect-ratio: 2/3;
    min-width: calc((100% / 2) - 2rem);
  }

  @media (min-width: 940px) {
    min-width: calc((100% / 3) - 4rem);
  }
}

.slider__image {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
}

.slider__info {
  position: relative;
  padding: 4rem 2rem 2rem;
  background: linear-gradient(to top, rgba(#000, 0.75), rgba(#203239, 0));

  h2 {
    color: #fff;
    font-family: system-ui;
    line-height: 1.1;
    font-weight: 300;
    font-size: 1.75rem;
    margin: 0;
  }
}

.slider__nav {
  margin: 1rem 0 4rem;
  width: 100%;
  padding: 0;
  display: flex;
  justify-content: flex-start;
  gap: 1rem;
  align-content: center;
  align-items: center;
  pointer-events: none;

  @media (min-width: 460px) {
    justify-content: flex-end;
  }
}

.slider__nav__button {
  margin: 0;
  appearance: none;
  border: 0;
  border-radius: 2rem;
  background: #fff;
  color: #203239;
  padding: 0.5rem 1rem;
  font-size: 0.75rem;
  line-height: 1;
  pointer-events: none;
  transition: 0.2s ease-out;
  opacity: 0.25;

  &--active {
    opacity: 1;
    pointer-events: auto;
    cursor: pointer;
  }
}
`


